import { render, staticRenderFns } from "./LaudoTransvaginalUteroParaPesquisaDeEndometriose.vue?vue&type=template&id=75c0d90e&"
import script from "./LaudoTransvaginalUteroParaPesquisaDeEndometriose.vue?vue&type=script&lang=js&"
export * from "./LaudoTransvaginalUteroParaPesquisaDeEndometriose.vue?vue&type=script&lang=js&"
import style0 from "./LaudoTransvaginalUteroParaPesquisaDeEndometriose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VRow,VSpacer})
